/*
 * Le Philtre — Pop-up de vérification d'âge (custom Post Scriptum)
 * Section autonome : ne dépend pas des internes Prestige, résiste aux mises à jour du thème.
 * Le verrouillage initial (classe html.age-gate-active) est posé par un script inline
 * synchrone dans la section, pour éviter tout flash de contenu avant le gate.
 */
(function () {
  'use strict';

  var ROOT_CLASS = 'age-gate-active';

  function storageFor(days) {
    // days <= 0 : mémorisation le temps de la session uniquement.
    try {
      return days > 0 ? window.localStorage : window.sessionStorage;
    } catch (e) {
      return null;
    }
  }

  // Décision « faut-il afficher le gate ? » — partagée avec le script inline via window.
  window.LePhiltreAgeGate = window.LePhiltreAgeGate || {};
  window.LePhiltreAgeGate.isVerified = function (key, days) {
    var store = storageFor(days);
    if (!store) return true; // pas de stockage → ne pas bloquer l'utilisateur indéfiniment
    var raw = store.getItem(key);
    if (!raw) return false;
    if (days <= 0) return raw === '1';
    var ts = parseInt(raw, 10);
    if (!ts) return false;
    var ageMs = Date.now() - ts;
    return ageMs < days * 24 * 60 * 60 * 1000;
  };

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  class AgeGate extends HTMLElement {
    connectedCallback() {
      this.key = this.getAttribute('storage-key') || 'theme:age-verified';
      this.days = parseInt(this.getAttribute('remember-days'), 10);
      if (isNaN(this.days)) this.days = 30;
      this.designMode = !!(window.Shopify && window.Shopify.designMode);

      this.dialog = this.querySelector('.age-gate__dialog');
      this.declineBox = this.querySelector('.age-gate__decline');
      this.actions = this.querySelector('.age-gate__actions');

      this._onKeydown = this._onKeydown.bind(this);

      this.addEventListener('click', this._onClick.bind(this));

      if (this.designMode) {
        // En éditeur de thème : afficher au clic sur la section, ne rien persister.
        document.addEventListener('shopify:section:select', this._show.bind(this));
        document.addEventListener('shopify:section:deselect', this._hide.bind(this));
        return;
      }

      // Le script inline a déjà posé la classe si non vérifié : on prend la main.
      if (document.documentElement.classList.contains(ROOT_CLASS)) {
        this._show();
      } else {
        this.remove();
      }
    }

    _show() {
      document.documentElement.classList.add(ROOT_CLASS);
      this.hidden = false;
      document.addEventListener('keydown', this._onKeydown, true);
      // Focus sur la première action pour l'accessibilité clavier.
      var first = this.querySelector(FOCUSABLE);
      if (first) {
        window.requestAnimationFrame(function () {
          first.focus();
        });
      }
    }

    _hide() {
      document.documentElement.classList.remove(ROOT_CLASS);
      document.removeEventListener('keydown', this._onKeydown, true);
      this.hidden = true;
    }

    _accept() {
      if (!this.designMode) {
        var store = storageFor(this.days);
        if (store) {
          try {
            store.setItem(this.key, this.days > 0 ? String(Date.now()) : '1');
          } catch (e) {}
        }
      }
      this.classList.add('is-leaving');
      var self = this;
      var done = function () {
        self._hide();
        if (!self.designMode) self.remove();
      };
      // Laisse jouer la transition CSS, avec repli si pas de transitionend.
      var fallback = window.setTimeout(done, 500);
      this.addEventListener(
        'transitionend',
        function () {
          window.clearTimeout(fallback);
          done();
        },
        { once: true }
      );
    }

    _decline() {
      // Mineur : on masque les actions et on révèle le message, sans laisser entrer.
      if (this.actions) this.actions.hidden = true;
      if (this.declineBox) {
        this.declineBox.hidden = false;
        var link = this.declineBox.querySelector(FOCUSABLE);
        if (link) link.focus();
      }
    }

    _onClick(event) {
      var el = event.target.closest('[data-age-action]');
      if (!el) return;
      event.preventDefault();
      var action = el.getAttribute('data-age-action');
      if (action === 'enter') this._accept();
      else if (action === 'exit') this._decline();
    }

    _onKeydown(event) {
      // Impossible de fermer le gate au clavier (Échap neutralisé).
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (event.key !== 'Tab') return;
      // Piège de focus dans le dialogue.
      var focusables = Array.prototype.filter.call(
        this.querySelectorAll(FOCUSABLE),
        function (n) {
          return n.offsetParent !== null;
        }
      );
      if (!focusables.length) return;
      var firstEl = focusables[0];
      var lastEl = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === firstEl) {
        event.preventDefault();
        lastEl.focus();
      } else if (!event.shiftKey && document.activeElement === lastEl) {
        event.preventDefault();
        firstEl.focus();
      }
    }
  }

  if (!customElements.get('age-gate')) {
    customElements.define('age-gate', AgeGate);
  }
})();
